import "./posts.css";
import { Link, useLocation } from "react-router-dom";
import { PostAuthor } from "./PostAuthor";
import Loader from "../loader/Loader";
import { useState } from "react";
import fishmonsterImage from "../../assets/Assetstest/fishmonster.png"; 

export const PostItem = ({
  postID,
  category,
  title,
  description,
  playerID,
  thumbnail,
  createdAt,
  creator,
  repliesCount,
  viewsCount,
  lastReplier,
  lastReplierAvatar,
  lastReplyTime,
}: {
  postID: string;
  category: string;
  title: string;
  description: string;
  playerID: string;
  thumbnail: string | React.ReactNode;
  createdAt: any;
  creator: { _id: string; name: string };
  repliesCount: number;
  viewsCount: number;
  lastReplier: string | null;
  lastReplierAvatar?: string | undefined;
  lastReplyTime: string | null;
}): JSX.Element => {
  const shortTitle = title.length > 40 ? title.substr(0, 40) + "..." : title;
  const shortDescription =
    description.length > 60 ? description.substr(0, 60) + "..." : description;

  const [isloading, setIsLoading] = useState(false);
  const location = useLocation();

  const ForumCategoryPage = [
    "/forum/support/gamesupport",
    "/forum/support/websupport",
    "/forum/newsinformation/news",
    "/forum/newsinformation/updates",
    "/forum/gamediscussion/gamediscussion",
    "/forum/gamediscussion/help",
    "/forum/gamediscussion/lfg",
  ];

  const isForumCategoryPage = ForumCategoryPage.some((path) =>
    location.pathname.includes(path)
  );

  if (isloading) {
    return <Loader />;
  }

  return (
    <div className="post-item">
      <div className="post-item__header">
        <h2 className="post-item__title">
          <Link to={`../posts/${postID}`}>{shortTitle}</Link>
        </h2>
      </div>
  
      <div className="post-item__body">
        <p className="post-item__Text" dangerouslySetInnerHTML={{ __html: shortDescription }}></p>
      </div>
  
      <div className="post-item__footer">
        <div className="post-item__meta">
          <PostAuthor playerID={playerID} createdAt={createdAt} />
        </div>
        <div className="post-item__stats">
          <span className="last_replay">Likes: {repliesCount}</span>
          <span className="views">Views: {viewsCount}</span>
        </div>
        {!isForumCategoryPage && lastReplier && lastReplyTime && (
          <div className="post-item__last-reply">
            <div className="post-item__avatar">
              <img src={!!thumbnail ? String(thumbnail) : fishmonsterImage} alt="Fish Monster" width={40} height={40} />
            </div>
            <span>Last reply by {lastReplier}</span>
            <span>{lastReplyTime}</span>
          </div>
        )}
      </div>
    </div>
  );
};
